module.exports = __webpack_public_path__ + "img/jg6.c3956f21.png";